import apiClient from '../apiClient';

export const submitPartnerQualification = async (formData) => {
  try {
    console.log('Form Data:', formData);
    const client = await apiClient();
    const response = await client.post('/api/Common/partner-qualification', formData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to submit qualification request');
  }
};

export const submitFeedback = async (feedbackData) => {
  try {
    const client = await apiClient();
    const response = await client.post('/api/Common/feedback', feedbackData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to submit feedback');
  }
};

// City search removed - frontend now uses simple text input
// AI interprets city names in any language during guide generation